function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.35195 0.800049C2.02647 0.800049 0.951954 1.87457 0.951954 3.20005L0.951954 24.8C0.951954 26.1255 2.02647 27.2 3.35195 27.2C4.67744 27.2 5.75195 26.1255 5.75195 24.8L5.75195 3.20005C5.75195 1.87457 4.67744 0.800049 3.35195 0.800049ZM16.3459 7.50299C15.4086 6.56573 13.889 6.56573 12.9518 7.50299L9.35177 11.103C7.75177 12.703 7.75177 15.2971 9.35177 16.8971L12.9518 20.4971C13.889 21.4344 15.4086 21.4344 16.3459 20.4971C17.2831 19.5598 17.2831 18.0403 16.3459 17.103L13.2429 14L16.3459 10.8971C17.2831 9.95985 17.2831 8.44025 16.3459 7.50299Z",
  fill: "white"
});

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 28,
    viewBox: "0 0 18 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.734f26c0.svg";
export { ForwardRef as ReactComponent };